/**
 * Generated bundle index. Do not edit.
 */

export * from './resize-observers-public-api';
